export {};
//# sourceMappingURL=default-worker-definition.js.map